// extracted by mini-css-extract-plugin
export default {"backdrop":"FullPageLoader_backdrop__5ZnT4"};